<template>
  <div>
    <shared-outbound-consultation @outboundConsultationSuccess="outboundConsultationSuccess" @saveOutboundPopup="saveOutboundPopup"></shared-outbound-consultation>
  </div>
</template>

<script>
import SharedOutboundConsultation from '@/views/Shared/Consultations/Outbound'
import { EventBus } from '@/../eventbus'
import announcementSocket from '@/libs/sockets/announcements'

export default {
  name: 'Window.Consultation.Outbound',
  components: {
    SharedOutboundConsultation
  },
  data () {
    return {
      member_id: 0,
      callback_id: 0
    }
  },
  computed: {
    server () {
      return this.$store.getters.userInfo !== null ? this.$store.getters.userInfo.servers : {}
    }
  },
  mounted () {
    this.member_id = this.$route.params.id
    if (typeof this.$route.query.callback_id !== 'undefined') {
      this.callback_id = this.$route.query.callback_id
    }
    announcementSocket.setNode(this.server)
    EventBus.$emit('initLoadOutboundConsultation', { member_id: this.member_id, callback_id: this.callback_id })
  },
  methods: {
    outboundConsultationSuccess () {
      announcementSocket.getSocket().emit('init_message_management_count')
      this.$windowOpenerHelper.notifyOpener('reload_consultation_callback_member_table')
      if (window.opener && window.opener.$storeInboundOrOutboundPopup) {
        window.opener.$storeInboundOrOutboundPopup()
      }
      window.close()
    },
    saveOutboundPopup () {
      EventBus.$emit('initSaveOutboundConsultationFormData')
    }
  }
}
</script>

<style scoped>

</style>
